






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardPengkajianAkhirHayat from "./CardPengkajianAkhirHayat.vue";
import { storePengkajianAkhirHayat } from "@/store/modules/PengkajianAkhirHayatStore";

@Component({
  components: {
    CardPengkajianAkhirHayat
  }
})
export default class PengkajianAkhirHayatPage extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;
  @Prop({ default: false }) isActive!: boolean;

  get loading() {
    return storePengkajianAkhirHayat.loading;
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val && !storePengkajianAkhirHayat.list.length) {
      this.getByRegister();
    }
  }

  mounted() {
    if (this.isActive) {
      this.getByRegister();
    }
  }

  async getByRegister() {
    await storePengkajianAkhirHayat.getByRegister(this.register);
  }
}
